export default __webpack_public_path__ + "static/media/logo-footer-novetech-p.b8eae692.png";